const FunctionalVendor = {
    CALENDLY: 'ca',
};
const AnalyticalVendor = {
    GOOGLE_ANALYTICS: 'ga',
    CRAZY_EGG: 'ce',
    AWIN: 'aw',
};
const MarketingVendor = {
    MICROSOFT_ADVERTISING: 'ma',
    GOOGLE_MARKETING_PIXEL: 'gmp',
    GOOGLE_ADS: 'gad',
    GOOGLE_DISPLAY_VIDEO_360: 'gdv',
    FACEBOOK: 'fb',
    PINTEREST: 'pr',
    SNAPCHAT: 'sc',
    LINKEDIN: 'li',
    JOBSTER: 'js',
    TIKTOK: 'tt',
    REDDIT: 'rd',
};
export const Vendor = {
    ...FunctionalVendor,
    ...AnalyticalVendor,
    ...MarketingVendor,
};
export const ANALYTICAL_COOKIE_VENDORS = [
    AnalyticalVendor.GOOGLE_ANALYTICS,
    AnalyticalVendor.CRAZY_EGG,
    AnalyticalVendor.AWIN,
];
export const MARKETING_COOKIE_VENDORS = [
    MarketingVendor.MICROSOFT_ADVERTISING,
    MarketingVendor.GOOGLE_MARKETING_PIXEL,
    MarketingVendor.GOOGLE_ADS,
    MarketingVendor.GOOGLE_DISPLAY_VIDEO_360,
    MarketingVendor.FACEBOOK,
    MarketingVendor.PINTEREST,
    MarketingVendor.SNAPCHAT,
    MarketingVendor.LINKEDIN,
    MarketingVendor.JOBSTER,
    MarketingVendor.TIKTOK,
    MarketingVendor.REDDIT,
];
export const FUNCTIONAL_COOKIE_VENDORS = [FunctionalVendor.CALENDLY];
export const COOKIE_PREFERENCES_2023 = '20231107';
export const COOKIE_PREFERENCES_2025 = '20250507';
//# sourceMappingURL=types.js.map